class BionyQuiz extends HTMLElement {
  connectedCallback() {
    this.steps = Array.from(this.querySelectorAll('.biony-quiz__step'));
    this.results = Array.from(this.querySelectorAll('.biony-quiz__result'));
    this.progressBars = Array.from(this.querySelectorAll('.biony-quiz__progress-bar'));
    this.defaultResult = this.dataset.defaultResult || 'balance';
    this.current = 0;

    this.steps.forEach((step, index) => {
      const next = step.querySelector('.biony-quiz__next');
      const inputs = step.querySelectorAll('input[type="radio"]');
      inputs.forEach((input) => {
        input.addEventListener('change', () => {
          next.disabled = false;
        });
      });
      next.addEventListener('click', () => this.advance(index));
    });

    this.querySelectorAll('.biony-quiz__restart').forEach((btn) => {
      btn.addEventListener('click', () => this.restart());
    });
  }

  advance(index) {
    if (index < this.steps.length - 1) {
      this.showStep(index + 1);
    } else {
      this.showResult();
    }
  }

  showStep(index) {
    this.current = index;
    this.steps.forEach((step, i) => {
      step.hidden = i !== index;
    });
    this.results.forEach((result) => {
      result.hidden = true;
    });
    this.progressBars.forEach((bar, i) => {
      bar.classList.toggle('biony-quiz__progress-bar--active', i <= index);
    });
  }

  showResult() {
    const scores = { balance: 0, move: 0 };
    this.querySelectorAll('input[type="radio"]:checked').forEach((input) => {
      const target = input.dataset.target;
      if (target in scores) scores[target] += 1;
    });

    let winner = this.defaultResult;
    if (scores.balance > scores.move) winner = 'balance';
    if (scores.move > scores.balance) winner = 'move';

    this.steps.forEach((step) => {
      step.hidden = true;
    });
    this.progressBars.forEach((bar) => {
      bar.classList.add('biony-quiz__progress-bar--active');
    });

    let shown = false;
    this.results.forEach((result) => {
      const match = result.dataset.result === winner;
      result.hidden = !match;
      if (match) shown = true;
    });
    if (!shown && this.results.length > 0) {
      this.results[0].hidden = false;
    }
  }

  restart() {
    this.querySelectorAll('input[type="radio"]').forEach((input) => {
      input.checked = false;
    });
    this.steps.forEach((step) => {
      step.querySelector('.biony-quiz__next').disabled = true;
    });
    this.showStep(0);
  }
}

if (!customElements.get('biony-quiz')) {
  customElements.define('biony-quiz', BionyQuiz);
}
